import { call, put, takeLatest } from 'redux-saga/effects';
import * as AuditService from '../../../services/audit/audit.service';
import { FETCH_USER_ACTIVITY, FETCH_USER_ACTIVITY_FAILED, FETCH_USER_ACTIVITY_SUCCESSFUL } from './actions';

function* activityFetcher(action) {
  try {
    const { userId, pageNumber = 0, pageSize = 10 } = action.payload;
    const { data } = yield call(AuditService.getUserActivity, { userId }, { pageNumber, pageSize });

    yield put({
      type: FETCH_USER_ACTIVITY_SUCCESSFUL,
      payload: data,
    });
  } catch (e) {
    const message = e.errors?.[0]?.endUserMessage || 'Something went wrong';
    yield put({
      type: FETCH_USER_ACTIVITY_FAILED,
      payload: { message },
    });
  }
}

export default function* auditSaga() {
  yield takeLatest(FETCH_USER_ACTIVITY, activityFetcher);
}
